
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { AwardIcon, BarChart2Icon, ScaleIcon, GaugeIcon } from 'lucide-react';

interface ProcurementQualityDetailsProps {
  procurement: any; // Replace with proper type when available
}

export function ProcurementQualityDetails({ procurement }: ProcurementQualityDetailsProps) {
  const isMobile = useIsMobile();
  
  const getQualityGradeColor = () => {
    switch (procurement.quality_grade?.toLowerCase()) {
      case 'a':
      case 'premium':
        return 'text-green-600';
      case 'b':
      case 'standard':
        return 'text-blue-600';
      case 'c':
      case 'economy':
        return 'text-amber-600';
      default:
        return 'text-muted-foreground';
    }
  };
  
  const getQualityIcon = () => {
    switch (procurement.quality_grade?.toLowerCase()) {
      case 'a':
      case 'premium':
        return <AwardIcon className="h-5 w-5 text-green-600" />;
      case 'b':
      case 'standard':
        return <BarChart2Icon className="h-5 w-5 text-blue-600" />;
      case 'c':
      case 'economy':
        return <ScaleIcon className="h-5 w-5 text-amber-600" />;
      default:
        return <GaugeIcon className="h-5 w-5 text-muted-foreground" />;
    }
  };
  
  return (
    <div className="space-y-4">
      <div className={isMobile ? "grid grid-cols-1 gap-4" : "grid grid-cols-1 md:grid-cols-2 gap-4"}>
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2">Quality Grade</h3>
          <div className="flex items-center">
            {getQualityIcon()}
            <p className={`ml-1 ${getQualityGradeColor()} font-medium`}>
              {procurement.quality_grade || 'Not specified'}
            </p>
          </div>
        </div>
        
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2">Damage Return</h3>
          <p>
            {procurement.supports_damage_return 
              ? `Allowed (${procurement.damage_return_percentage || 0}%)` 
              : 'Not allowed'}
          </p>
        </div>
      </div>
      
      {procurement.quality_details && (
        <div className="p-4 border rounded-md">
          <h3 className="text-sm font-medium mb-2">Quality Notes</h3>
          <p className="text-sm text-muted-foreground">
            {procurement.quality_details}
          </p>
        </div>
      )}
      
      {!procurement.quality_details && !procurement.quality_grade && (
        <div className="p-4 border border-dashed rounded-md text-center">
          <p className="text-muted-foreground">
            No detailed quality information available for this procurement.
          </p>
        </div>
      )}
    </div>
  );
}
